"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HideScroll = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const StyledHideScrollWrapper = app_1.styled.div `
  overflow: hidden;
`;
const StyledHideScroll = app_1.styled.div `
  overflow: auto;
`;
const HideScrollCss = {
    right: (0, app_1.css) `
    margin-right: -50px;
    padding-right: 50px;
  `,
    bottom: (0, app_1.css) `
    margin-bottom: -50px;
    padding-bottom: 50px;
  `,
    both: (0, app_1.css) `
    margin-bottom: -50px;
    padding-bottom: 50px;
    margin-right: -50px;
    padding-right: 50px;
  `,
};
exports.HideScroll = (0, react_1.forwardRef)(({ side = 'bottom', children, className, onScroll }, ref) => {
    return ((0, jsx_runtime_1.jsx)(StyledHideScrollWrapper, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(StyledHideScroll, Object.assign({ css: HideScrollCss[side], ref: ref, onScroll: onScroll }, { children: children })) })));
});
